// src/views/Pages/Invoices/useInvoicePDF.ts
import { useEffect, useState } from "react";
import { getJwt } from "src/auth";

const BASE_URL = process.env.NODE_ENV === "production" ? "https://www.docuclipper.com" : "http://localhost:8080";

const useInvoicePDF = ({
  transactionLine,
  selectedDocumentId,
}) => {
  const pageNumber = transactionLine ? transactionLine.pageNumber : 0;
  const [presignedUrl, setPresignedUrl] = useState<string>("");

  useEffect(() => {
    let cancelled = false;
    const jwt = getJwt();

    if (!selectedDocumentId || !transactionLine || !jwt) {
      setPresignedUrl("");
      return;
    }

    (async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/v1/protected/document/${selectedDocumentId}/downloads3`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${jwt}`,
            },
          },
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch presigned URL: ${response.statusText}`);
        }

        const data = await response.json();
        if (!cancelled) {
          setPresignedUrl(data.url);
        }
      } catch (err) {
        if (!cancelled) {
          console.error("useInvoicePDF: failed to fetch presigned URL", err);
          setPresignedUrl("");
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [selectedDocumentId, transactionLine?.id]);

  const pdfURL = presignedUrl
    ? `${presignedUrl}#page=${pageNumber + 1}&toolbar=0`
    : "";

  return {
    pdfURL,
    pageNumber,
  };
};

export default useInvoicePDF;
